module.exports = __webpack_public_path__ + "static/avilabs-icon-4a0cac4af5867287984eb70e7b51e41b.png";